module.exports = __webpack_public_path__ + "static/media/img_succession_planning_02.9f94de25.png";